import CustomerPage from "@/views/customer/CustomerPage.vue";
import CourseArea from "@/views/customer/children/course/Course.vue";
import Dashboard from "@/views/customer/children/dashboard/Dashboard.vue";
import CustomerProfile from "@/views/customer/children/profile/Profile.vue";
import CustomerClasses from "@/views/customer/children/classes/Classes.vue";
import CustomerCalendar from "@/views/customer/children/calendar/Calendar.vue";
import CourseContentPage from "@/views/customer/children/course/CourseContent.vue";
import ModuleLessons from "@/views/customer/children/course/ModuleLessons.vue";
import TeacherExtras from "@/views/customer/children/course/TeacherExtras.vue";
import NotificationsArea from "@/views/customer/children/notifications/NotificationsArea.vue";
import CustomerFinance from "@/views/customer/children/finance/Finance.vue";
import CompleteInfo from "@/views/customer/CompleteInfo.vue";
import CustomerMessages from "@/views/customer/children/messages/Messages.vue";
import SurveyAnswerPage from "@/components/surveys/SurveyAnswerPage.vue";
import ExercisePage from "@/views/customer/children/exercises/ExercisePage.vue";
import PitchCoinsPage from "@/components/coins/PitchCoinsPage.vue";
import StudyPlan from "@/views/customer/children/studyPlan/StudyPlan.vue";
import Certificates from "@/views/customer/children/certificates/Certificates.vue";

const prefix = "/connect/aluno";

export const customer_routes = [
  {
    path: `${prefix}/completar-informacoes`,
    name: "CompletarInformacoes",
    component: CompleteInfo,
    meta: { authRequired: true, preventAuth: true },
  },
  {
    path: prefix,
    name: "Bem-vindo",
    component: CustomerPage,
    meta: { authRequired: true, preventAuth: true },
    children: [
      {
        path: `${prefix}/cockpit`,
        name: "Dashboard",
        component: Dashboard,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/perfil`,
        name: "Perfil",
        meta: { authRequired: true, preventAuth: true },
        component: CustomerProfile,
      },
      {
        path: `${prefix}/curso`,
        name: "Curso",
        meta: { authRequired: true, preventAuth: true },
        component: CourseArea,
      },
      {
        // Aluno solo: aulas de um modulo (cards -> aulas). Declarado antes de
        // '/curso/:id' (material) por ter profundidade maior.
        path: `${prefix}/curso/modulo/:id`,
        name: "Aulas do modulo",
        meta: { authRequired: true, preventAuth: true },
        component: ModuleLessons,
      },
      {
        // Card 17trt6jfxtn: declarado antes de '/curso/:id' para "indicados"
        // não virar id de aula.
        path: `${prefix}/curso/indicados`,
        name: "Indicados pelo professor",
        meta: { authRequired: true, preventAuth: true },
        component: TeacherExtras,
      },
      {
        path: `${prefix}/curso/:id`,
        name: "Aulas",
        meta: { authRequired: true, preventAuth: true },
        component: CourseContentPage,
      },
      {
        path: `${prefix}/turmas`,
        name: "Turmas",
        meta: { authRequired: true, preventAuth: true },
        component: CustomerClasses,
      },
      // Card 17trt6jbffe: Mensagens (chat com professor, turma e suporte).
      {
        path: `${prefix}/mensagens`,
        name: "Mensagens aluno",
        meta: { authRequired: true, preventAuth: true },
        component: CustomerMessages,
      },
      {
        path: `${prefix}/notificacoes`,
        name: "Notificacoes",
        meta: { authRequired: true, preventAuth: true },
        component: NotificationsArea,
      },
      {
        path: `${prefix}/agenda`,
        name: "Agenda",
        meta: { authRequired: true, preventAuth: true },
        component: CustomerCalendar,
      },
      {
        path: `${prefix}/financeiro`,
        name: "Financeiro",
        meta: { authRequired: true, preventAuth: true },
        component: CustomerFinance,
      },
      {
        // Card 17trt6jd8uu: saldo, como ganhar e extrato de coins.
        path: `${prefix}/pitch-coins`,
        name: "Pitch Coins aluno",
        meta: { authRequired: true, preventAuth: true },
        component: PitchCoinsPage,
        props: { profile: "customer" },
      },
      {
        // Card 86akj8q08: plano de estudos do aluno autonomo.
        path: `${prefix}/plano-de-estudos`,
        name: "Plano de estudos aluno",
        meta: { authRequired: true, preventAuth: true },
        component: StudyPlan,
      },
      {
        // Card 17trt6jfkw8: certificados emitidos pelo proprio aluno.
        path: `${prefix}/certificados`,
        name: "Certificados aluno",
        meta: { authRequired: true, preventAuth: true },
        component: Certificates,
      },
      {
        // Card 86akqxu0h: formulario de pesquisa enviado pela escola.
        path: `${prefix}/formularios/:id`,
        name: "Formulario aluno",
        meta: { authRequired: true, preventAuth: true },
        component: SurveyAnswerPage,
        props: { profile: "customer" },
      },
      {
        // Card 17trt6jcyfb: exercicio no Connect (os PDFs novos podem
        // apontar para ca; o login vem antes).
        path: `${prefix}/exercicios/:id`,
        name: "Exercicio aluno",
        meta: { authRequired: true, preventAuth: true },
        component: ExercisePage,
      },
    ],
  },
];
